"use client";
import { AspectRatio } from "@radix-ui/react-aspect-ratio";
import { CarouselContent, CarouselItem } from "./gallery-carousel";
import { VideoComponent } from "../common/video";
import { GalleryItmes } from "../types/common";

type SlideShowProps = {
  items: GalleryItmes;
  currentItem: number | null;
};

export default function SlideShow({ items, currentItem }: SlideShowProps) {
  if (currentItem === null) return;

  return (
    <CarouselContent className="lg:max-w-[90vw] xl:max-w-[1280px]">
      {items.map((_, index) => (
        <CarouselItem key={index}>
          <AspectRatio ratio={16 / 9}>
            <VideoComponent
              thumbnail={_.image_link ?? ""}
              videoUrl={_.video_link! ?? ""}
            />
          </AspectRatio>
        </CarouselItem>
      ))}
    </CarouselContent>
  );
}
